/**
 * Reactive hook for the Chatwoot onboarding localStorage flag.
 *
 * The Chatwoot iframe sets `chatwoot_onboarding_opened` in localStorage
 * when the user first opens the inbox. Since localStorage writes from the
 * same tab don't fire `storage` events, we also poll every 5 seconds.
 */

import { useSyncExternalStore, useCallback } from "react";

const STORAGE_KEY = "chatwoot_onboarding_opened";

function getSnapshot(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function getServerSnapshot(): boolean {
  return false;
}

export function useChatwootOpened(): boolean {
  const subscribe = useCallback((onStoreChange: () => void) => {
    // Cross-tab reactivity via storage event
    const handleStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) onStoreChange();
    };
    window.addEventListener("storage", handleStorage);

    // Same-tab polling (Chatwoot iframe sets localStorage from within the page)
    const interval = setInterval(onStoreChange, 5000);

    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(interval);
    };
  }, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
